import { render, staticRenderFns } from "./BtnReservaAhora.vue?vue&type=template&id=0491b1dd&scoped=true"
import script from "./BtnReservaAhora.vue?vue&type=script&lang=js"
export * from "./BtnReservaAhora.vue?vue&type=script&lang=js"
import style0 from "./BtnReservaAhora.vue?vue&type=style&index=0&id=0491b1dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0491b1dd",
  null
  
)

export default component.exports